import React, { useState } from 'react';
import './PartnerStories.css';
import partnerStoriesData from './partnerStories.json';
import ActionButton from '../elements/ActionButton/ActionButton';
import OptimizedImage from './OptimizedImage';
import gatoradeImg from 'url:../../assets-optimized/redesign/partnerStories/gatorade.png';
import gatoradeImgavif from 'url:../../assets-optimized/redesign/partnerStories/gatorade.avif';
import gatoradeImgwebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade.webp';
import visaImg from 'url:../../assets-optimized/redesign/partnerStories/visa.jpg';
import visaImgavif from 'url:../../assets-optimized/redesign/partnerStories/visa.avif';
import visaImgwebp from 'url:../../assets-optimized/redesign/partnerStories/visa.webp';
import unitedImg from 'url:../../assets-optimized/redesign/partnerStories/united.jpg';
import unitedImgavif from 'url:../../assets-optimized/redesign/partnerStories/united.avif';
import unitedImgwebp from 'url:../../assets-optimized/redesign/partnerStories/united.webp';
import gatoradeLogo from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.png';
import gatoradeLogoavif from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.avif';
import gatoradeLogowebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.webp';
import visaLogo from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.png';
import visaLogoavif from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.avif';
import visaLogowebp from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.webp';
import unitedLogo from 'url:../../assets-optimized/redesign/partnerStories/united_logo.png';
import unitedLogoavif from 'url:../../assets-optimized/redesign/partnerStories/united_logo.avif';
import unitedLogowebp from 'url:../../assets-optimized/redesign/partnerStories/united_logo.webp';

const images = {
  gatorade: { avif: gatoradeImgavif, webp: gatoradeImgwebp, fallback: gatoradeImg },
  visa: { avif: visaImgavif, webp: visaImgwebp, fallback: visaImg },
  united: { avif: unitedImgavif, webp: unitedImgwebp, fallback: unitedImg },
};

const logos = {
  gatorade: { avif: gatoradeLogoavif, webp: gatoradeLogowebp, fallback: gatoradeLogo },
  visa: { avif: visaLogoavif, webp: visaLogowebp, fallback: visaLogo },
  united: { avif: unitedLogoavif, webp: unitedLogowebp, fallback: unitedLogo },
};

const PartnerStories = () => {
  const [activeTab, setActiveTab] = useState(0);

  const activeStudy = partnerStoriesData[activeTab];

  const scrollToContent = () => {
    const element = document.getElementById('partner-stories-content');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id='partner-stories' className='partner-stories-section'>
      <h2 className='partner-stories-title'>Partner success Stories</h2>

      <div className='partner-stories-arrow' onClick={scrollToContent}>
        <svg viewBox='0 0 24 24'>
          <path d='M12 5v14M5 12l7 7 7-7' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <div id='partner-stories-content' className='partner-stories-nav'>
        {partnerStoriesData.map((study, index) => (
          <button
            key={study.id}
            className={`partner-story-btn custom_click_track ${index === activeTab ? 'active' : ''}`}
            data-custom_click_track_value={`Partner Stories|Tab ${study.name}|Internal|`}
            onClick={() => setActiveTab(index)}
          >
            {study.name}
          </button>
        ))}
      </div>

      <div className='partner-story-header-block'>
        <h3 className='cs-main-title'>{activeStudy.name}</h3>
        <p className='cs-main-desc'>{activeStudy.description}</p>
      </div>

      <div
        className='partner-story-outer-card'
        style={{ backgroundColor: activeStudy.color }}
        key={activeTab}
      >
        <div className='partner-story-inner-container'>
          <div className='cs-inner-left'>
            <OptimizedImage
              {...logos[activeStudy.id]}
              className='cs-floating-logo'
              alt={`${activeStudy.name} logo`}
            />
            <OptimizedImage
              {...images[activeStudy.id]}
              alt={activeStudy.title}
              className='cs-featured-image'
              style={activeTab === 2 ? { transform: 'translateX(-25%)' } : undefined}
            />
          </div>

          <div className='cs-inner-right'>
            {activeStudy.stats.map((stat, index) => (
              <div key={index} className='cs-stat-item'>
                <div className='cs-stat-value'>
                  {stat.value} <span>{stat.unit}</span>
                </div>
                <div className='cs-stat-desc'>{stat.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div className='cs-footer-banner'>
          <span className='cs-footer-text'>EXPLORE PARTNER STORIES</span>
          <div className='cs-footer-actions'>
            <ActionButton url='/#/partner-stories' text='See all' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerStories;
